module.exports = __webpack_public_path__ + "static/media/logo.1028dc9c.png";